import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";

export const CustomTooltipWithoutHeaderChartWrapper = styled.div<NectarTheme>`
  ${({ theme }) => css`
    .apexcharts-tooltip-series-group {
      margin-top: ${theme.spacings.xs} !important;
      margin-bottom: 2px !important;
    }
  `}
`;
